/**
 * src/db/footer.db.js
 *
 * Datos de la sección Footer.
 */

export const footerData = {
    brand: {
        src:     '/logo.png',
        alt:     'UBIYAAA',
        name:    '',
        tagline: 'Directorio particular en Fusagasugá. Directorio de negocios y servicios locales.',
        contact: [
            { icon: '📱', label: '312 428 8323',  href: 'https://wa.me/573124288323' },
            { icon: '🌐', label: 'ubiyaaafusa.com', href: 'https://ubiyaaafusa.com'   }
        ]
    },
    linkGroups: [
        {
            title: 'Navegar',
            links: [
                { label: 'Inicio',      href: '/'            },
                { label: 'Directorio',  href: '/directorio'  },
                { label: 'Promociones', href: '/promociones' },
                { label: 'Contacto',    href: '/contacto'    },
                { label: 'Registrar anuncio', href: '/registrar' }
            ]
        },
        {
            title: 'Links',
            links: [
                { label: 'Descargar App',         href: '/descargar'          },
                { label: 'Política de privacidad',href: '/privacidad'         },
                { label: 'Términos y condiciones',href: '/terminos'           }
            ]
        }
    ],
    apps: [
        { store: 'App Store',    icon: '🍎', href: '#', label: 'Disponible en' },
        { store: 'Google Play',  icon: '▶️', href: '#', label: 'Disponible en' }
    ],
    copyright: `© ${new Date().getFullYear()} UBIYAAA. Todos los derechos reservados.`
}
